import React from 'react'
import {FaCreativeCommonsZero} from 'react-icons/fa'

function Empty({objectName}) {
    return (
        <div className='alert border border-slate-500 rounded-md mt-3 px-4 justify-center'>
            <FaCreativeCommonsZero className='h-7 w-7 text-secondary'/>
            <p>No {objectName} found yet!</p>
        </div>
    )
}

export default Empty